export default __webpack_public_path__ + "img/c60228615fd1197543d2cc944956c954.png";